import { render, staticRenderFns } from "./gradationText.vue?vue&type=template&id=32f89bf7"
import script from "./gradationText.vue?vue&type=script&lang=js"
export * from "./gradationText.vue?vue&type=script&lang=js"
import style0 from "./gradationText.vue?vue&type=style&index=0&id=32f89bf7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports